import { db } from "./firebase";
import {
  collection, addDoc, getDocs, updateDoc, deleteDoc,
  doc, query, where, orderBy, serverTimestamp
} from "firebase/firestore";

const COL = "shopOrders";

export async function createShopOrder(data) {
  return await addDoc(collection(db, COL), {
    customerEmail: data.customerEmail.toLowerCase().trim(),
    customerName:  data.customerName,
    items:         data.items, // array of {link, price, discount, notes, quantity, total}
    grandTotal:    data.grandTotal,
    status:        "Pending", // Pending | Confirmed | Ordered | Arrived | Rejected
    adminNotes:    "",
    createdAt:     serverTimestamp(),
    updatedAt:     serverTimestamp(),
  });
}

export async function getCustomerShopOrders(email) {
  const q = query(
    collection(db, COL),
    where("customerEmail", "==", email.toLowerCase().trim()),
    orderBy("createdAt", "desc")
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function getAllShopOrders() {
  console.log("Fetching shop orders...");
  const snap = await getDocs(collection(db, COL));
  console.log("Shop orders count:", snap.docs.length);
  const docs = snap.docs.map(d => ({ id: d.id, ...d.data() }));
  console.log("Shop orders data:", docs);
  return docs.sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
}

export async function updateShopOrder(id, status, adminNotes) {
  await updateDoc(doc(db, COL, id), {
    status,
    adminNotes: adminNotes || "",
    updatedAt:  serverTimestamp(),
  });
}

export async function deleteShopOrder(id) {
  await deleteDoc(doc(db, COL, id));
}
